/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaLinkedin,
} from "react-icons/fa";

import BackToTop from "./BacktoTop";

const offices = {
  India: [
    {
      city: "Mohali",
      address: `Gemba Infotech,
Quark Atrium,
Phase 8B, Mohali, India`,
      mapLink:
        "https://www.google.com/maps/search/?api=1&query=Quark+Atrium+Phase+8B+Mohali",
    },
    {
      city: "Chandigarh",
      address: `Gemba Infotech
SCO 224, Level 1&2, Sector 37C,
Chandigarh 160036, India`,
      mapLink:
        "https://www.google.com/maps/search/?api=1&query=SCO+224+Sector+37C+Chandigarh",
    },
  ],
  USA: [
    {
      city: "Delaware",
      address: `GEMBA INFOTECH LLC
254 Chapman Rd, Ste 208 #23639
Newark, Delaware 19702`,
      mapLink:
        "https://www.google.com/maps/search/?api=1&query=254+Chapman+Rd+Newark+Delaware",
    },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 px-6 py-10 text-gray-700">

      {/* TOP SECTION: CONTACT LEFT / OUR OFFICES RIGHT */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10">

        {/* CONTACT US - LEFT */}
        <div>
          <h3 className="text-2xl font-bold text-slate-800 mb-4">
            Contact Us
          </h3>

          <p className="flex items-center gap-2 mt-2">
            <FaPhone /> +91-172-4659657
          </p>

          <p className="flex items-center gap-2 mt-2">
            <FaEnvelope /> sales-team@gembainfotech.com
          </p>

          <div className="mt-6">
            <h4 className="font-semibold text-lg">Follow Us</h4>
            <a
              href="https://www.linkedin.com/company/gemba-infotech/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-2xl text-blue-700 hover:text-teal-500 mt-2 inline-block"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>

        {/* OUR OFFICES - RIGHT */}
        <div className="flex flex-col">
          <h2 className="text-3xl font-bold text-slate-800 mb-6 text-center md:text-left pl-20 md:pl-24">
            Our Offices
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
            {/* INDIA */}
            <div>
              <h4 className="text-xl font-semibold mb-4 flex items-center gap-2">
                🇮🇳 India
              </h4>

              {offices.India.map((loc, i) => (
                <a
                  key={i}
                  href={loc.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mb-4 hover:text-slate-900 transition"
                >
                  <p className="font-semibold flex items-center gap-2">
                    <FaMapMarkerAlt className="text-red-600" />
                    {loc.city}
                  </p>
                  <p className="text-sm whitespace-pre-line ml-6 text-gray-600">
                    {loc.address}
                  </p>
                </a>
              ))}
            </div>

            {/* USA */}
            <div>
              <h4 className="text-xl font-semibold mb-4 flex items-center gap-2">
                🇺🇸 USA
              </h4>

              {offices.USA.map((loc, i) => (
                <a
                  key={i}
                  href={loc.mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mb-4 hover:text-slate-900 transition"
                >
                  <p className="font-semibold flex items-center gap-2">
                    <FaMapMarkerAlt className="text-red-600" />
                    {loc.city}
                  </p>
                  <p className="text-sm whitespace-pre-line ml-6 text-gray-600">
                    {loc.address}
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="border-t border-slate-300 mt-10 pt-4 text-sm flex items-center">
        <p>© 2022 Gemba Infotech. All Rights Reserved.</p>
        <div className="ml-auto">
          <BackToTop />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
